/**
 * @generated SignedSource<<31968bea61ef9acddda227b4e6b54482>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type timeline_nativeIssueTable_TimelineCellRenderer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"timelineCell_issueTableTimeline">;
  readonly " $fragmentType": "timeline_nativeIssueTable_TimelineCellRenderer";
};
export type timeline_nativeIssueTable_TimelineCellRenderer$key = {
  readonly " $data"?: timeline_nativeIssueTable_TimelineCellRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"timeline_nativeIssueTable_TimelineCellRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "isTimelineEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "timeline_nativeIssueTable_TimelineCellRenderer",
  "selections": [
    {
      "condition": "isTimelineEnabled",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "FragmentSpread",
          "name": "timelineCell_issueTableTimeline"
        }
      ]
    }
  ],
  "type": "JiraIssueEdge"
};

(node as any).hash = "9f504f38329d12e194f001379f0dec9f";

export default node;
